import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      borderColor: theme.palette.common.white,
      color: theme.palette.common.white,
      flexShrink: 0,
      textTransform: 'none',
      whiteSpace: 'nowrap',
    },
    iconButton: {
      color: theme.palette.common.white,
      flexShrink: 0,
    },
  })
) as unknown as UseStylesFunction
